import { OAuth2 } from "@backstage/core-app-api";
import {
	AnyApiFactory,
	BackstageIdentityApi,
	configApiRef,
	createApiFactory,
	createApiRef,
	discoveryApiRef,
	OpenIdConnectApi,
	oauthRequestApiRef,
	ProfileInfoApi,
	SessionApi,
} from "@backstage/core-plugin-api";
import {
	ScmAuth,
	ScmIntegrationsApi,
	scmIntegrationsApiRef,
} from "@backstage/integration-react";

export const zendosAuthApiRef = createApiRef<
	OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({ id: "auth.zendos" });

export const apis: AnyApiFactory[] = [
	createApiFactory({
		api: zendosAuthApiRef,
		deps: {
			discoveryApi: discoveryApiRef,
			oauthRequestApi: oauthRequestApiRef,
			configApi: configApiRef,
		},
		factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
			OAuth2.create({
				configApi,
				discoveryApi,
				oauthRequestApi,
				environment: configApi.getOptionalString("auth.environment"),
				provider: {
					id: "oidc",
					title: "Zendos login",
					icon: () => null,
				},
				defaultScopes: ["openid", "profile", "email"],
			}),
	}),
	createApiFactory({
		api: scmIntegrationsApiRef,
		deps: { configApi: configApiRef },
		factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
	}),
	ScmAuth.createDefaultApiFactory(),
];
